/** Shared clock helpers so mock data always reads as "now" relative to today. */

export function daysFromNow(days: number, hour = 9): string {
  const date = new Date()
  date.setDate(date.getDate() + days)
  date.setHours(hour, 0, 0, 0)
  return date.toISOString()
}

export function minutesFromNow(minutes: number): string {
  const date = new Date()
  date.setMinutes(date.getMinutes() + minutes, 0, 0)
  return date.toISOString()
}

export function hoursFromNow(hours: number): string {
  return minutesFromNow(hours * 60)
}
